import React, { useContext } from 'react';
import { InputField } from '@ubeya/shared-web/components';
import { onlyPositiveNumber } from '@ubeya/shared/utils/form';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const RatesFields = ({ isFlatWage }) => {
  const { t } = useContext(ConfigContext);
  return (
    <>
      <InputField name="wage.hourlyWage" title={t('clientWage')} type="number" autoFocus onChange={parseFloat} />
      <InputField
        name="payrollWage.hourlyWage"
        title={t('specificClientPayRate')}
        type="number"
        onChange={parseFloat}
      />

      {isFlatWage && (
        <>
          <>
            <InputField
              name="payrollWage.flatWage"
              title={`${t('flatWage')}`}
              onChange={onlyPositiveNumber}
              type="number"
            />
            <InputField
              name="payrollWage.flatHours"
              title={t('flatHours')}
              onChange={onlyPositiveNumber}
              type="number"
            />
          </>

          <>
            <InputField name="wage.flatWage" title={`${t('globalWage')}`} onChange={onlyPositiveNumber} type="number" />
            <InputField
              name="wage.flatHours"
              title={t('flatBillRateHoursLimit')}
              onChange={onlyPositiveNumber}
              type="number"
            />
          </>
        </>
      )}
    </>
  );
};

export default RatesFields;
